module.exports = __webpack_public_path__ + "static/media/FloorScrape2_After.62ab744e.jpg";